import React, { useContext } from 'react';
import { CustomerRequestContext } from '../CustomerRequestContext';

export const TabsContext = React.createContext(null);

export const TabsProvider = (props) => {
    const { 
        values,
        setFieldValue,
        resetForm,
        isSubmitting,
    } = props;

    const { isSavingRequest } = useContext(CustomerRequestContext);
    
    const { Provider } = TabsContext;

    return (
        <Provider value={{
            values,
            setFieldValue,
            resetForm,
            isSubmitting,
            isSavingRequest
        }}>
            {props.children}
        </Provider>
    );
}